import React from 'react';
import { FolderInput } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SlidingFolderInputIconProps {
  className?: string;
  size?: number;
}

export const SlidingFolderInputIcon: React.FC<SlidingFolderInputIconProps> = ({
  className,
  size,
}) => {
  return (
    <FolderInput
      size={size}
      className={cn(
        'h-4 w-4 shrink-0 transition-transform duration-300 group-hover:translate-x-0.5',
        className,
      )}
    />
  );
};
